module.exports = __webpack_public_path__ + "img/case1-6.343e15d8.jpg";